import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { tap } from "rxjs/operators";
import {
  BlobService,
  LoggingService,
  PartnerTypes,
  RedirectService,
  SeoService,
  SessionService,
  VENUE_REQUEST_VENUE_USER_URL,
} from "src/app/core";
import { VenueRequestWizardInput } from "src/app/features/customer-requests";
import { VenueRequestWizardComponent, VenueRequestWizardPostSubmitDialogComponent } from "src/app/features/customer-requests/components";
import { Animations, InstructionsCarouselStep } from "src/app/shared";

@Component({
  selector: "app-venue-request",
  templateUrl: "./venue-request.component.html",
  styleUrls: ["./venue-request.component.scss"],
  animations: [Animations.buildDefaultFadeInAnimation(550)],
  standalone: false,
})
export class VenueRequestComponent implements OnInit {
  @ViewChild(VenueRequestWizardComponent) venueRequestWizardComponent: VenueRequestWizardComponent;

  isVenueUser: boolean;
  constructor(
    private _sessionService: SessionService,
    private _seoService: SeoService,
    private _matDialog: MatDialog,
    private _blobService: BlobService,
    private _redirectService: RedirectService,
    private _loggingService: LoggingService,
  ) {}

  venueRequestWizardConfig: VenueRequestWizardInput = {
    padding: "0px",
  };

  howItWorksStepsVenueUser: InstructionsCarouselStep[];

  ngOnInit(): void {
    this.isVenueUser = this._sessionService.isCurrentPartnerType(PartnerTypes.Venue);
    this._seoService.postFixTitle("Venue Request");

    this.howItWorksStepsVenueUser = [
      {
        title: 'Click "Get Started"',
        blurb: `Fill out our "Request A Demo" form and our team will reach out to kickstart the process of adding a new venue or room.`,
        image: this._blobService.getAssetBlobUrl("custom-venue-selection-request-venue-upload.jpg"),
      },
      {
        title: "We Build",
        blurb: `We will use the floor plan and reference images to create an accurate 3D space & add it to the site.`,
        image: this._blobService.getAssetBlobUrl("custom-venue-selection-request-venue-build.jpg"),
      },
      {
        title: "You Design",
        blurb: "You can design your full event in the 3D venue space, including furniture, décor, and more!",
        image: this._blobService.getAssetBlobUrl("custom-venue-selection-request-venue-design.jpg"),
      },
    ];
  }

  onAfterSubmit(): void {
    this._matDialog
      .open(VenueRequestWizardPostSubmitDialogComponent, {
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .pipe(
        tap(result => {
          if (result) {
            this.venueRequestWizardComponent.resetForm();
          } else {
            this._sessionService.redirectUserToDefault(true);
          }
        }),
      )
      .subscribe();
  }

  onGetStartedVenueUserClick(): void {
    this._loggingService.logWorkflow(
      "Venue Request Venue User get started click",
      "VenueRequestComponent.onGetStartedVenueUserClick",
      "VenueRequest",
      "VenueRequestVenueUser",
      "VenueRequestStandalone",
    );

    this._redirectService.redirectExternal(VENUE_REQUEST_VENUE_USER_URL, "_blank");
  }
}
